module.exports = "<div #baAmChart class=\"ba-am-chart {{baAmChartClass || ''}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/theme/components/baAmChart/baAmChart.html
// module id = ../../../../../src/app/theme/components/baAmChart/baAmChart.html
// module chunks = main